export default __webpack_public_path__ + "static/media/alert.321ce9fc.png";